<template>
	<div class="view-invoice">
		<Modal
			:show="showInvoice"
			content_class="col-12 col-lg-9 col-xl-8 confirm-modal"
		>
			<template slot="content" v-if="selected_invoice && invoice_details">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">
								Invoice for
								{{
									invoice_details.student_details.student_name
								}}
							</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showInvoice', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="no-padding">
						<div class="row">
							<div class="col-12 col-lg-11 col-xl-10">
								<div class="intermediary-box">
									<div class="clearfix">
										<div
											class="status f-r"
											:class="{
												'tx-yellow':
													invoice_details.invoice_status ===
													'pending:payment',
											}"
										>
											{{ invoice_details.invoice_status }}
										</div>
									</div>
									<div class="clearfix">
										<div class="image-box f-l">
											<img
												:src="
													invoice_details
														.school_details
														.school_image
														? api.getDomain() +
															'/' +
															invoice_details
																.school_details
																.school_image
														: '/img/logo-1.png'
												"
												alt=""
												class="image"
											/>
										</div>
										<div class="name-box f-l">
											<div class="ref tx-uppercase">
												{{
													invoice_details.parent_fee_invoice_system_ref
												}}
											</div>
											<div class="ref">
												{{
													invoice_details
														.student_details
														.student_name
												}}
											</div>
											<div class="ref">
												{{
													invoice_details
														.school_details
														.school_name
												}}
											</div>
											<!-- <div class="class">FEE STRUCTURE FOR {{invoice_details.class}}</div> -->
											<div class="total">
												{{
													invoice_details.invoice_currency ||
													'¤'
												}}
												{{
													utils.numberWithCommas2(
														invoice_details.total_amount,
													)
												}}
											</div>
											<div class="in-date date">
												Generated At:
												{{
													moment(
														invoice_details.invoice_date,
													).format('Do MMM YYYY')
												}}
											</div>
											<div
												v-if="
													invoice_details.payment_details &&
													invoice_details
														.payment_details
														.payment_ref
												"
											>
												<div
													class="pay-date date"
													v-if="
														invoice_details
															.payment_details
															.payment_date
													"
												>
													Paid At:
													{{
														moment(
															invoice_details
																.payment_details
																.payment_date,
															'D/M/YYYY',
														).format('Do MMM YYYY')
													}}
												</div>
												<div class="payment-ref">
													Payment Ref:
													{{
														invoice_details
															.payment_details
															.payment_ref
													}}
												</div>
											</div>

											<!-- <Dropdown class="fx-dropdown" trigger="click" @on-click="clickAction($event)" >
                                    <div class="btn btn-red btn-long">
                                       <i class="fa fa-wrench"></i>
                                       Actions
                                       <i class="fa fa-chevron-down"></i>
                                    </div>
                                    <DropdownMenu slot="list">
                                       <DropdownItem name="payment_breakdown">
                                             <div class="clearfix">
                                             <i class="fa fa-money-check-alt"></i> 
                                             <div class="menu-text">Payment Breakdown</div> 
                                             </div>
                                       </DropdownItem>
                                       <DropdownItem name="make_payment">
                                             <div class="clearfix">
                                             <i class="fa fa-credit-card"></i> 
                                             <div class="menu-text">Make Payment</div> 
                                             </div>
                                       </DropdownItem>
                                       <DropdownItem name="get_financing" disabled>
                                             <div class="clearfix">
                                                <i class="fa fa-hand-holding-usd"></i> 
                                                <div class="menu-text">Get Financing</div> 
                                             </div>
                                       </DropdownItem>
                                    </DropdownMenu>
                                 </Dropdown> -->
										</div>
									</div>
									<div class="btn-box">
										<div
											class="row justify-content-md-center"
										>
											<div
												class="col-md-5 mr-2"
												@click="showPaymentBreakdown()"
											>
												<a
													class="tooltip-hover btn btn-primary btn-long"
												>
													<i
														class="fa fa-money-check-alt"
													></i>
													Payment Breakdown
												</a>
												<div class="description-hover">
													<div class="h6">
														Payment Breakdown
													</div>
													<p class="text">
														Get the school fees
														breakdown per term
													</p>
												</div>
											</div>
											<div
												class="col-md-5 ml-2"
												@click="showMakePayment()"
												v-if="
													invoice_details.nexus_invoice_details &&
													invoice_details
														.nexus_invoice_details
														.invoice
														.invoice_status !==
														'paid'
												"
											>
												<a
													class="tooltip-hover btn btn-green btn-long"
												>
													<i
														class="fa fa-credit-card"
													></i>
													Make Payment
												</a>
												<div class="description-hover">
													<div class="h6">
														Make Payment
													</div>
													<p class="text">
														Make payment for this
														invoice
													</p>
												</div>
											</div>
											<div class="col-md-12 mt-5" v-else>
												<div
													class="h6 tx-red tx-center"
												>
													Invoice already paid
												</div>
											</div>
										</div>
									</div>
								</div>

								<div
									class="card fee-card"
									v-if="
										invoice_details.nexus_invoice_details
											.invoice
									"
								>
									<div class="term title">
										<div class="row item">
											<div class="col-md-2">Qty</div>
											<div class="col-md-6">
												Description
											</div>
											<div class="col-md-4 tx-right">
												Amount
											</div>
										</div>
									</div>
									<div
										class="term"
										v-for="(item, k) in invoice_details
											.nexus_invoice_details.invoice
											.invoice_description"
										:key="k"
									>
										<div class="row price-item">
											<div class="col-md-2 item-title">
												{{ item.quantity }}
											</div>
											<div class="col-md-6 item-desc">
												{{ item.description }}
											</div>
											<div class="col-md-4 amount">
												{{
													invoice_details.currency ||
													'¤'
												}}
												{{
													utils.numberWithCommas2(
														item.amount,
													)
												}}
											</div>
										</div>
									</div>

									<div class="sum-total clearfis">
										<div class="total f-r">
											{{
												invoice_details.currency || '¤'
											}}
											{{
												utils.numberWithCommas2(
													invoice_details.total_amount,
												)
											}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
export default {
	components: {
		Modal: () => import('../templates/others/modal'),
		Dropdown: () => import('@/libs/clarks/components/dropdown/dropdown'),
		DropdownItem: () =>
			import('@/libs/clarks/components/dropdown/dropdown-item'),
		DropdownMenu: () =>
			import('@/libs/clarks/components/dropdown/dropdown-menu'),
	},
	computed: {
		...mapGetters([
			'loading',
			'selected_invoice',
			'invoice_details',
			'showInvoice',
		]),
	},
	data() {
		return {
			api,
			utils,
			moment,
		};
	},
	methods: {
		...mapActions([
			'clickAction',
			'showMakePayment',
			'showPaymentBreakdown',
		]),
		calculateTotal(term) {
			let total = 0;
			for (let i = 0; i < term.mandatory.length; i++) {
				if (term.mandatory[i].cost) {
					total += term.mandatory[i].cost;
				}
			}

			for (let i = 0; i < term.optional.length; i++) {
				if (term.optional[i].cost) {
					total += term.optional[i].cost;
				}
			}

			return ` ${utils.numberWithCommas(total)}`;
		},
	},
	mounted() {},
};
</script>

<style lang="less">
.view-invoice {
	.tx-right {
		text-align: right;
	}
	.btn-box {
		margin: 50px 0;
	}
	.tooltip-hover {
		position: absolute;
		top: -15px;
		right: 5px;
		left: 5px;
		color: var(--text-color);
		cursor: pointer;
	}
	.description-hover {
		display: none;
		position: absolute;
		top: 10;
		left: 0;
		z-index: 4000;
		-webkit-box-shadow: -1px 4px 27px 2px rgba(221, 213, 240, 0.8);
		-moz-box-shadow: -1px 4px 27px 2px rgba(221, 213, 240, 0.8);
		box-shadow: -1px 4px 27px 2px rgba(221, 213, 240, 0.8);
		background: #fff;
		width: 280px;
		height: auto;
		padding: 10px;
		border-radius: 5px;
		text-align: center;

		.h6 {
			font-size: 14px;
			font-weight: 600;
		}
		.text {
			width: 100%;
			white-space: initial;
			font-size: 13px;
		}
		&:hover {
			display: block;
		}
	}
	.tooltip-hover:hover + div {
		display: block;
	}
	.intermediary-box {
		border-radius: 4px;
		border: solid 1px #e6eaee;
		background: var(--white);
		padding: 20px 15px;
		margin: 10px 0;
		cursor: pointer;

		.image-box {
			margin: 0 30px 0 0;

			.image {
				border-radius: 4px;
				width: auto;
				height: auto;
				max-width: 80px;
				max-height: 80px;
				margin: 5px 0 0 0;
			}
		}
		.insurer {
			color: var(--ne-blue);
			font-weight: 600;
			font-size: 12px;
		}
		.name-box {
			width: calc(100% - 120px);
		}

		.payment-ref {
			font-size: 12px;
			text-transform: uppercase;
			font-weight: 600;
			color: var(--ne-green);
		}
		.status {
			font-size: 12px;
			text-transform: uppercase;
			font-weight: 600;
			color: var(--ne-green);

			&.tx-yellow {
				color: var(--ne-yellow);
			}
		}
		.date {
			font-weight: 600;
			font-size: 13px;
		}

		.ref {
			font-size: 13px;
			font-weight: 600;
		}
		.class {
			font-size: 13px;
			text-transform: uppercase;
			font-weight: 600;
		}
		.total {
			color: var(--ne-blue);
			font-weight: 600;
			font-size: 16px;
		}
	}
}
</style>
